import { Injectable } from '@angular/core';

@Injectable()
export class FileSelectionStoreService {
  private selectedFiles: Map<string, File> = new Map();

  constructor() {}

  get files(): File[] {
    return Array.from(this.selectedFiles.values());
  }

  add(file: File): boolean {
    if (this.selectedFiles.has(file.name)) {
      return false;
    } else {
      this.selectedFiles.set(file.name, file);
      return true;
    }
  }

  remove(file: File): boolean {
    if (this.selectedFiles.has(file.name)) {
      this.selectedFiles.delete(file.name);
      return true;
    } else {
      return false;
    }
  }

  clear() {
    this.selectedFiles.clear();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/file-selection-store/file-selection-store.service.ts